import { Box, Button as MuiButton, styled, Typography } from '@mui/material';

export const Container = styled(Box)`
  flex: 1;
  overflow-y: auto;
`;

export const InputContainer = styled(Box)`
  padding: 10px 20px;
`;
export const RemoveVariationButton = styled(MuiButton)(
  ({ theme }) => `
color:${theme.palette.brand.red};
font-weight: 400;
font-size: 1rem;
text-decoration-line: underline;
padding: 0;
`,
);
export const RemoveVariationButtonContainer = styled(Box)`
  position: relative;
  bottom: 0;
  margin-bottom: 20px;
  padding: 10px 20px;
`;

export const StartIcon = styled(Typography)(
  ({ theme }) => `
  display: flex;
  width: 20px;
  height: 20px;
  background: ${theme.palette.primary.main};
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-size: 0.8rem;
  margin-right: 8px;
`,
);

export const TagLabel = styled(Typography)`
  margin-top: 8px;
`;

export const AssemblySectionRotationAreaContainer = styled(Box)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
